





































import { Vue, Component, Prop } from 'vue-property-decorator';

export interface User {
  rank: number;
  osuId: number;
  owc?: boolean;
  username: string;
}

@Component
export default class Leaderboard extends Vue {
  @Prop() leaderboard: User[];

  openProfile(osuId: number) {
    window.open(`https://osu.ppy.sh/users/${osuId}`, '_blank');
  }
}
